import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import IntlCurrencyInput from "react-intl-currency-input";

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};


class HeaderPedido extends Component {
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.utilizarSaldo = this.utilizarSaldo.bind(this);

        this.state = {
            openModal: false,
            valorDesconto: 0,

        };

    }
    toggleModal() {
        this.setState({
            openModal: !this.state.openModal

        }, () => {
            if (this.state.openModal) {
                this.setState({ valorDesconto: 0 })
            }
        })
    }
    onChangeInput(e, valorDigitado, maskedValue) {
        const _name = e.target.name,
            _value = e.target.name === "valorDesconto" ? valorDigitado : e.target.value;
        // _value = e.target.value
        this.setState({ [_name]: _value })
    }

    utilizarSaldo() {
        this.props.inserirDescontoPedido(this.state.valorDesconto);
        this.setState({
            openModal: false,
            valorDesconto: 0
        })
    }

    render() {
        return (
            <div className="header-pedido border-left border-bottom border-gray">
                <div className="row no-gutters px-3 py-3">
                    <div className="offset-1 col-3">
                        <div className="row no-gutters">
                            <div className="col-12">
                                <p className="my-1">Subtotal do pedido: R$ {this.props.valorSubtotal.toFixed(2).toString().replace(".", ",")}</p>
                                {this.props.freteAtivo || this.props.opcaoEntrega === "2" ? (
                                    <p className="my-1">Valor do frete: R$ {this.props.valorFrete.toFixed(2).toString().replace(".", ",")}</p>
                                ) : (
                                    <p className="my-1">Valor do frete: <span className="badge badge-warning">pendente</span></p>
                                )}
                                <h5 className="my-2">Valor total do pedido: R$ {this.props.valorTotalPedido.toFixed(2).toString().replace(".", ",")}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-3 text-center align-items-end d-flex">
                        {this.props.saldoOriginal > 0 && (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <strong> Saldo disponível: <span className={this.props.saldoAtual > 0 ? "text-success" : "text-danger"}>
                                        R$ {!!this.props.saldoAtual ? this.props.saldoAtual.toFixed(2).toString().replace('.', ',') : "0,00"}</span></strong>
                                </div>
                                <div className="col-12">
                                    <button onClick={this.toggleModal} className="btn btn-outline-info mt-2">utilizar saldo</button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="col-3 text-center align-items-end d-flex">
                        <div className="row">
                            {this.props.isLoadingFinalizaPedido ? (
                                <div className="spinner-border text-primary" role="status" />

                            ) : (
                                <div className="col-12 text-center">
                                    <button disabled={this.props.habilitaFinalizarPedido()} onClick={this.props.finalizarPedido} className="btn btn-outline-success">finalizar pedido</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.openModal} toggle={this.toggleModal} className="modal-utilizar-saldo">
                    <ModalHeader toggle={this.toggleModal}>Utilização do saldo</ModalHeader>
                    <ModalBody>
                        {this.props.valorTotalPedido > 0 ? (
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <span><strong> Valor total do pedido: R$ {this.props.valorTotalPedido.toFixed(2).toString().replace(".", ",")}</strong></span>
                                        </div>
                                        <div className="col-12 text-center mt-2">
                                            <span><strong>Saldo disponível: <span className={this.props.saldoAtual > 0 ? "text-success" : "text-danger"}>
                                                R$ {!!this.props.saldoAtual ? this.props.saldoAtual.toFixed(2).toString().replace('.', ',') : "0,00"}</span></strong></span>
                                        </div>
                                        {this.state.valorDesconto > this.props.valorMaxDesconto && (
                                            <div className="col-12 py-3 text-center">
                                                <p className="text-danger">Valor digitado maior que o máximo permitido.</p>
                                            </div>
                                        )}
                                        <div className="col-6 mt-3">
                                            <label> Valor que deseja utilizar</label>
                                            <IntlCurrencyInput currency="BRL" config={currencyConfig}
                                                autoComplete="off" name="valorDesconto"
                                                className="form-control input-saldo-utilizado"
                                                value={this.state.valorDesconto}
                                                onChange={this.onChangeInput}
                                            />
                                        </div>
                                        <div className="col-6 align-items-end d-flex px-2 justify-content-end">
                                            <button onClick={this.utilizarSaldo} disabled={(this.state.valorDesconto > this.props.saldoAtual) || this.state.valorDesconto === 0} className="btn btn-outline-success">Utilizar saldo
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <p className="m-0">Para utilizar o saldo disponível insira pelo menos um item no pedido.</p>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div >
        );
    }
}

export default HeaderPedido;